import { useOrganization, CreateOrganization, OrganizationProfile, PricingTable } from '@clerk/react';
import Sidebar from '../components/Sidebar';
import ApiKeysPanel from '../components/ApiKeysPanel';
import WebhooksPanel from '../components/WebhooksPanel';
import { IconCard, IconKey, IconWebhook } from '../components/icons';

export default function Team() {
  const { isLoaded, organization } = useOrganization();

  return (
    <div className="flex h-screen bg-bg font-sans text-ink">
      <Sidebar active="team" />
      <div className="flex flex-1 flex-col overflow-hidden">
        <div className="flex h-14 shrink-0 items-center gap-4 border-b border-border2 px-6">
          <div className="font-display text-base font-bold">Team</div>
        </div>
        <div className="flex flex-1 items-start justify-center overflow-auto p-6">
          {!isLoaded ? null : organization ? (
            <OrganizationProfile path="/team" routing="path">
              <OrganizationProfile.Page label="Billing" url="billing" labelIcon={<IconCard />}>
                <PricingTable for="organization" />
              </OrganizationProfile.Page>
              <OrganizationProfile.Page label="API Keys" url="api-keys" labelIcon={<IconKey />}>
                <ApiKeysPanel />
              </OrganizationProfile.Page>
              <OrganizationProfile.Page label="Webhooks" url="webhooks" labelIcon={<IconWebhook />}>
                <WebhooksPanel />
              </OrganizationProfile.Page>
            </OrganizationProfile>
          ) : (
            <div className="flex w-full max-w-lg flex-col items-center gap-4 pt-10 text-center">
              <div className="font-display text-lg font-bold">Create your team</div>
              <p className="max-w-sm text-sm text-muted">
                Set up an organization to invite teammates by email and manage roles and permissions.
              </p>
              <CreateOrganization afterCreateOrganizationUrl="/team" skipInvitationScreen={false} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
